"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  name: 'CommonTableLabel',
  props: {
    value: {
      type: Array,
      default: () => []
    },
    tableColumns: {
      type: Array,
      default: () => []
    },
    config: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    setConfig() {
      return Object.assign({
        show: ['refresh', 'filter', 'search'] // 自定义类型 刷新:refresh  列过滤:filter 搜索显示:search
      }, this.config);
    }
  },
  watch: {
    value(a) {
      this.$emit('input', a);
    }
  },
  methods: {
    refresh() {
      this.$emit('refresh');
    },
    setNodes(type) {
      return this.setConfig.show.includes(type);
    },
    search() {
      this.$emit('search');
    }
  }
};